import { Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { ArrowRight, Dumbbell, Waves, Trophy, ShieldCheck } from "lucide-react";
import Wordmark from "@/components/Wordmark";

export default function Landing() {
  const registerUrl = `${window.location.origin}/register?qr=Main%20Gate`;
  return (
    <div className="min-h-screen text-white" style={{ background: "linear-gradient(160deg,#081226 0%,#0D1C38 55%,#081226 100%)" }}>
      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <Wordmark />
        <Link to="/login" data-testid="landing-admin-login-link"
          className="text-sm font-semibold px-4 py-2 rounded-full border border-[#E8752A]/40 text-[#FFD9B8] hover:bg-[#E8752A]/10 transition-colors">
          Team Login
        </Link>
      </header>

      <main className="max-w-6xl mx-auto px-6 pt-10 pb-20 grid md:grid-cols-2 gap-14 items-center">
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-[#E8752A] uppercase mb-5">
            <span className="w-2 h-2 rounded-full bg-[#E8752A]" /> Fitness · Sports · Leisure
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight">
            Welcome to <span className="text-[#E8752A]">Oneiros Varachha</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-md">
            Scan, register in under a minute, and collect your digital visitor pass. No app needed — right from your browser.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/register?qr=Main%20Gate" data-testid="landing-register-btn"
              className="inline-flex items-center gap-2 px-7 py-4 rounded-full font-bold text-white text-lg shadow-xl transition-transform hover:scale-[1.02]"
              style={{ background: "linear-gradient(135deg,#FFA14D,#E85D1F)" }}>
              Register your visit <ArrowRight size={20} />
            </Link>
          </div>
          <div className="mt-10 flex gap-6 text-slate-300">
            {[[Dumbbell, "Gym"], [Waves, "Swimming"], [Trophy, "Sports"], [ShieldCheck, "Secure Pass"]].map(([Icon, label], i) => (
              <div key={i} className="flex items-center gap-2 text-sm">
                <Icon size={18} className="text-[#E8752A]" /> {label}
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center fade-up">
          <div className="bg-white rounded-3xl p-8 shadow-2xl border border-[#E8752A]/30 text-center max-w-xs">
            <p className="font-display font-bold text-[#081226] text-lg mb-1">Scan to Register</p>
            <p className="text-xs text-slate-500 mb-5">Point your camera at the code</p>
            <div className="bg-white p-3 rounded-2xl inline-block border border-slate-100">
              <QRCodeCanvas value={registerUrl} size={190} fgColor="#081226" level="M" />
            </div>
            <p className="mt-5 text-xs text-slate-400">Oneiros Varachha — Main Gate</p>
          </div>
        </div>
      </main>
    </div>
  );
}
